import ChangePasswordView from './views/ChangePasswordView.vue'

export default [
  {
    path: '/cambio-clave',
    name: 'changePassword',
    component: ChangePasswordView
  }
]
